import { SpaceBetween } from "@cloudscape-design/components-themed";
import Main from "../components/application-information/Main";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS, USER_TYPE } from "../configs/constants";
import { useCanIShowHook } from "../app/useCanIShowHook";

/*
申請情報更新
*/

const ApplicationInformationUpdate = () => {
  //権限制御
  const hasAuthority = useAuthenticationHook(PERMISSIONS.PROGRESS);
  // 事業者種別取得
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  return (
    <SpaceBetween size="l">
      {isDocomoUser && hasAuthority && <Main />}
    </SpaceBetween>
  );
};

export default ApplicationInformationUpdate;
